import React from "react";
import {
    BrowserRouter as Router,
    Redirect,
    Route,
    Switch,
} from "react-router-dom";
import AppMenu from "./AppMenu";
import LoginPage from "./page/LoginPage";
import CheckinPage from "./page/CheckinPage";
import AppStore from "./AppStore";
import {FormattedMessage, IntlProvider} from "react-intl";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import CheckoutPage from "./page/CheckoutPage";
import AccountPage from "./page/AccountPage";
import HomePage from "./page/HomePage";
import moment from "moment";
import ContactPage from "./page/ContactPage";

//                    <Loading loading={true} background={"transparent"} loaderColor={"#536BE2"}/>



// This example has 3 pages: a public page, a protected
// page, and a login screen. In order to see the protected
// page, you must first login. Pretty standard stuff.
//
// First, visit the public page. Then, visit the protected
// page. You're not yet logged in, so you are redirected
// to the login page. After you login, you are redirected
// back to the protected page.
//
// Notice the URL change each time. If you click the back
// button at this point, would you expect to go back to the
// login page? No! You're already logged in. Try it out,
// and you'll see you go back to the page you visited
// just *before* logging in, the public page.

export default function App() {
    const appStore = React.useContext(AppStore);

    // inicializamos el store con los datos que vienen en el archivo de configuracion del resort
    appStore.initializeStore();

    // Ya fue, no entiendo bien como funciona esto, ya perdi demasiado tiempo :(
    const [, setLanguage] = React.useState(appStore);

    appStore.setLanguage = (language) => {
        appStore.language = language;

        setLanguage(language)

        moment.locale(language);
        appStore.saveSession();
    };

    moment.locale(appStore.language);

    return (
        <AppStore.Provider value={appStore}>
            <IntlProvider locale={appStore.language} messages={appStore.languageList[appStore.language].messages}>
                <MuiPickersUtilsProvider utils={MomentUtils} locale={appStore.language}>
                    <Router>
                        <Switch>
                            <Route path="/:tenant([A-Za-z0-9]+)/:resort([0-9]+)" component={ResortApp} />
                            <Route path="*">
                                <h3>Page not found!</h3>
                            </Route>
                        </Switch>
                    </Router>
                </MuiPickersUtilsProvider>
            </IntlProvider>
        </AppStore.Provider>
    );
}

function ResortApp({match})
{
    const appStore = React.useContext(AppStore);

    appStore.setResortData(window['resortConfig']);

    return (
        <Switch>
            <Route path={`${match.path}/public`} component={PublicPage} />

            <Route path={`${match.path}/login`} component={LoginPage} />

            <PrivateRoute path={`${match.path}/home`} title={<FormattedMessage id="app.menu.home"/>}>
                <HomePage/>
            </PrivateRoute>

            <PrivateRoute path={`${match.path}/checkin`} title={"Web Checkin"}>
                <CheckinPage/>
            </PrivateRoute>

            <PrivateRoute path={`${match.path}/account`} title={<FormattedMessage id="app.menu.account"/>}>
                <AccountPage/>
            </PrivateRoute>

            <PrivateRoute path={`${match.path}/contact`} title={<FormattedMessage id="app.menu.contact"/>}>
                <ContactPage/>
            </PrivateRoute>

            <PrivateRoute path={`${match.path}/checkout`} title={"Checkout"}>
                <CheckoutPage/>
            </PrivateRoute>

            <Route path="*">
                <h3>Page for resort not found!</h3>
            </Route>
        </Switch>
    )
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, title, ...rest }) {
    const appStore = React.useContext(AppStore);

    return (
        <Route
            {...rest}
            render={({ location, history, match }) =>
                appStore.isLogged() ? (
                    <AppMenu
                        match={match}
                        history={history}
                        title={title}
                        children={children}
                    />
                ) : (
                    <Redirect
                        to={{
                            pathname: `/${match.params['tenant']}/${match.params['resort']}/login`,
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

function PublicPage() {
    return <h3>Public</h3>;
}
